<script>
import SvgLoader from 'components/svg_loader.vue';

export default {
  components: {
    SvgLoader
  },

  props: {
    showHr: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>

<template>
  <div class="c-powered-by-paypro">
    <hr
      v-if="showHr"
      class="d-md-none m-4 mt-0"
    >

    <div class="d-flex align-items-center justify-content-center">
      <span>{{ t('pay.js.marketing.payment_footer.powered_by') }}</span>

      <a
        href="https://www.paypro.nl"
        target="_blank"
        class="d-flex"
      >
        <svg-loader
          class="d-flex"
          path="logo"
        />
      </a>
    </div>
  </div>
</template>
